<div class="d-flex justify-content-end">
    <mdb-form-control>
      <input
        mdbInput
        type="text"
        class="form-control"
        id="search-input"
        (keyup)="search($event)"
      />
      <label mdbLabel class="form-label" for="search-input">Buscar Logs</label>
    </mdb-form-control>
  </div>
  <hr />
  <div class="datatable table-editor">
    <table
      class="table datatable-table"
      mdbTable
      mdbTableSort
      #table="mdbTable"
      #sort="mdbTableSort"
      [dataSource]="dataSource"
      [sort]="sort"
      [pagination]="pagination"
      width="100%"
      border-collapse="collapse" 
    >
      <thead class="datatable-header">
        <tr>
          <th
            *ngFor="let header of headers"
            [mdbTableSortHeader]="header.field"
            [disableSort]="header.disableSort"
            scope="col"
            style="white-space: normal; text-align: center;"
          >
            {{ header.label | titlecase }}
          </th>
        </tr>
      </thead>
      <tbody class="datatable-body" *ngIf="!loading">
        <tr *ngFor="let data of table.data; let index = index;" scope="row" style="">
          <td style="min-width: 100px; max-width: 100px; padding: 2px; white-space: normal; text-align: center;">
            {{ data.CREATION_DATE_ORDER }}
          </td>
          <td style="min-width: 100px; max-width: 100px; padding: 2px; white-space: normal; text-align: center;">
            {{ data.NUM_DOC }}
          </td>
          <td style="min-width: 100%; max-width: 100%; padding: 2px; white-space: normal; text-align: center;">
            {{ data.CLIENTE }}
          </td>
          <td style="min-width: 200px; max-width: 200px; padding: 2px; white-space: normal; text-align: center;">
            {{ data.EMAIL }}
          </td>
          <td style="min-width: 100%; max-width: 100%; padding: 2px; white-space: normal; text-align: center;">
            {{ data.CARD_CODE }}
          </td>
          <td style="min-width: 320px; max-width: 320px; padding: 2px; white-space: normal; text-align: center;">
            {{ data.CONTACTOS }}
          </td>
          <td style="min-width: 50px; max-width: 50px; padding: 2px; white-space: normal; text-align: center;">
            <span *ngIf="data.GENERO_PDF === '1'">
              <i class="fa fa-check text-success"></i>
            </span>
            <span *ngIf="data.GENERO_PDF !== '1'">
              <i class="fa fa-circle text-danger"></i>
            </span>
          </td>
          <td style="min-width: 150px; max-width: 150px; padding: 2px; white-space: normal; text-align: center;">
            {{ data.STATUS_ENVIO_EMAIL }}
          </td>
          <td style="min-width: 50px; max-width: 50px; padding: 2px; white-space: normal; text-align: center;">
            <span *ngIf="data.USUARIO_GENERO_OC !== null">
              <i class="fa fa-check text-success"></i>
            </span>
            <span *ngIf="data.USUARIO_GENERO_OC === null">
              <i class="fa fa-circle text-danger"></i>
            </span>
          </td>
          <td style="min-width: 100px; max-width: 100px;  padding: 2px; white-space: normal; text-align: center;">
            {{ data.CREATED_AT }}
          </td>
          <td style="min-width: 100px; max-width: 100px;  padding: 2px; white-space: normal; text-align: center;">
            {{ data.NUMERO_SOLICITUD }}
          </td>
          <td style="min-width: 100px; max-width: 100px;  padding: 2px; white-space: normal; text-align: center;">
            {{ data.SOLICITANTE }}
          </td>
          <td style="min-width: 150px; max-width: 150px;  padding: 2px; white-space: normal; text-align: center;">
            {{ data.SOLICITANTE_EMAIL }}
          </td>
        </tr>
      </tbody>
    </table>
    <ng-container *ngIf="loading">
      <div class="datatable-loader bg-light">
        <span class="datatable-loader-inner">
          <span class="datatable-progress bg-primary"></span>
        </span>
      </div>
      <p class="text-center text-muted my-4">Cargando información...</p>
    </ng-container>
    <mdb-table-pagination 
    #pagination 
    [entries]="25"
    [disabled]="loading"></mdb-table-pagination>
  </div>
  <!--<mdb-loading [show]="loadingFull" [fullscreen]="true">
    <div class="loading-spinner">
      <div class="spinner-border loading-icon" role="status"></div>
      <span class="loading-text">Cargando datos...</span>
    </div>
  </mdb-loading>-->
